if (!window.customElements.get('ring-size-updater')) {
  class RingSizeUpdater extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const item = this.closest('[data-ring-line-item]');
      if (!item) return;
      let currentVariantId = item.dataset.variantId;
      let currentDiamondId = item.getAttribute('data-diamond-id');
      let dropdown = item.querySelector('select');
      let updateBtn = item.querySelector('.cart-table-item-update');
      //var option1 = item.querySelector('.wetheme-custom-radio:checked').value || null;
      var fingerSize = dropdown ? dropdown.value : null;
      dropdown?.addEventListener('change', (e) => {
        const selectedValue = e.target.value;
        fingerSize = selectedValue;
      });

      updateBtn?.addEventListener('click', (e) => {
        console.log('Selected Variant:', currentVariantId);
        const cartData = JSON.parse(document.querySelector('#initial-cart').textContent);

        if (currentVariantId) {
          const cartItem = cartData.items.find((item) => item.id == currentVariantId);
          let currentProperties = Object.assign({}, cartItem?.properties || {});

          // Strip every size-shaped key (e.g. `Size`, `fingerSize`,
          // `ring_size`) so the line ends up with exactly one
          // `Finger size` property — the cart selector's value.
          Object.keys(currentProperties).forEach((key) => {
            const normalized = key.toLowerCase().replace(/[\s_-]/g, '');
            if (normalized === 'fingersize'
              || normalized === 'size'
              || normalized === 'ringsize') {
              delete currentProperties[key];
            }
          });

          currentProperties['Finger size'] = fingerSize;
          if (currentDiamondId) {
            currentProperties['_diamond'] = currentDiamondId;
          }

          let formDataAdd = {
            id: currentVariantId,
            quantity: cartItem ? cartItem.quantity : 1,
            properties: currentProperties,
            attributes: {
              ring: {
                option2: fingerSize,
              },
            },
          };
          fetch(`/cart/change.js`, {
            body: JSON.stringify(formDataAdd),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
          })
            .then((res) => res.json())
            .then((data) => {
              window.location.href = '/cart';
            });
        }
      });
    }
  }

  customElements.define('ring-size-updater', RingSizeUpdater);
}
